import { Component } from '@angular/core';

@Component({
  selector: 'app-start-register',
  imports: [],
  templateUrl: './start-register.component.html',
  styles: ``
})
export class StartRegisterComponent {

}
